<template>
  <div>
    <div class="min-vh-100">
      <b-container class="px-0">
        <b-row class="no-gutters px-0">
          <b-col sm="4" class="text-center text-sm-left mb-3 mb-sm-0">
            <h1 class="mb-0 mb-sm-3 header-main text-uppercase header-inline">
              Email Config
            </h1>
          </b-col>
        </b-row>
        <div class="mt-3 bg-white-border p-3">
          <b-row class="mt-3">
            <b-col>
              <h3 class="font-weight-bold">Message Log</h3>
            </b-col>
          </b-row>
          <b-row class="mt-2">
            <b-col xl="6">
              <div>
                <b-input-group class="panel-input-email">
                  <b-form-input
                    class="input-custom"
                    @keyup.13="onAddEmail"
                    v-model="email"
                  ></b-form-input>
                  <b-input-group-append>
                    <b-button class="btn btn-add-email">
                      <font-awesome-icon class="" size="sm" icon="plus"
                    /></b-button>
                  </b-input-group-append>
                </b-input-group>
              </div>

              <div class="px-3 py-2 mb-2 email-card">
                <div class="d-flex flex-wrap" v-if="isShowAllEmail">
                  <div
                    v-for="(email, index) in form.email"
                    :key="index"
                    class="d-flex email-box p-1 m-1"
                  >
                    <div class="m-auto text-email px-2">
                      {{ email }}
                    </div>
                    <div class="ml-3">
                      <font-awesome-icon
                        class="my-auto"
                        icon="times"
                        @click="onDeleteEmail(email)"
                      />
                    </div>
                  </div>
                </div>
                <div v-else class="d-flex flex-wrap">
                  <div
                    v-for="(email, index) in form.email.slice(0, 10)"
                    :key="index"
                    class="d-flex email-box p-1 m-1"
                  >
                    <div class="m-auto text-email px-2">
                      {{ email }}
                    </div>
                    <div class="ml-2 mr-1">
                      <font-awesome-icon
                        class="my-auto"
                        icon="times"
                        @click="onDeleteEmail(email)"
                      />
                    </div>
                  </div>
                </div>
                <div
                  class="ml-1 my-auto text-main-color w-100 text-right"
                  @click="isShowAllEmail = true"
                  v-if="form.email.length > 10 && !isShowAllEmail"
                >
                  See more ({{ form.email.length }})
                </div>
              </div>

              <div v-if="$v && $v.$error" class="text-error">
                กรุณากรอกอีเมลให้ถูกต้อง (เช่น email@example.com)
              </div>
            </b-col>
          </b-row>

          <b-row class="mt-5">
            <b-col class="text-sm-right">
              <button
                type="button"
                @click="checkForm()"
                :disabled="isDisable"
                class="btn btn-main btn-details-set ml-md-2 text-uppercase"
              >
                SAVE
              </button>
            </b-col>
          </b-row>
        </div>
      </b-container>
    </div>
    <ModalAlert ref="modalAlert" :text="modalMessage" />
    <ModalAlertError ref="modalAlertError" :text="modalMessage" />
    <ModalLoading ref="modalLoading" :hasClose="false" />
  </div>
</template>

<script>
import ModalAlert from "@/components/modal/alert/ModalAlert";
import ModalAlertError from "@/components/modal/alert/ModalAlertError";
import ModalLoading from "@/components/modal/alert/ModalLoading";
import { required, email } from "vuelidate/lib/validators";

export default {
  components: {
    ModalAlert,
    ModalAlertError,
    ModalLoading,
  },
  data() {
    return {
      emailList: [],
      email: null,
      form: {
        typeId: 1,
        email: [],
      },
      isShowAllEmail: false,
      isError: false,
      isDisable: false,
      modalMessage: "",
    };
  },
  validations: {
    email: { required, email },
  },
  created: async function () {
    await this.getEmailList();
  },
  methods: {
    getEmailList: async function () {
      await this.axios.get(`${this.$baseUrl}/system/email/1`).then((data) => {
        if (data.result == 1) {
          this.form.email = data.detail;
        }
      });
    },
    onAddEmail() {
      this.$v.$touch();
      if (this.$v.email.$error) {
        return;
      } else {
        if (this.email && !this.form.email.includes(this.email)) {
          this.form.email.push(this.email.trim());
          this.email = "";
          this.$v.$reset();
        }
      }
    },
    checkForm() {
      this.submit();
    },
    submit: async function () {
      this.isDisable = true;
      this.$refs.modalLoading.show();
      await this.axios
        .post(`${this.$baseUrl}/system/email`, this.form)
        .then((data) => {
          if (data.result == 1) {
            this.modalMessage = "สำเร็จ";
            this.$refs.modalLoading.hide();
            this.$refs.modalAlert.show();
            this.getEmailList();
            this.$v.$reset();
          } else {
            this.modalMessage = data.message;
            this.$refs.modalLoading.hide();
            this.$refs.modalAlertError.show();
          }
          this.isDisable = false;
        });
    },
    onDeleteEmail(email) {
      const index = this.form.email.indexOf(email);
      if (index > -1) {
        if (this.form.email) {
          this.form.email.splice(index, 1);
          this.$v.$reset();
        }
      }
    },
  },
};
</script>

<style scoped>
.btn-add-email {
  margin: 0.175rem;
  padding: 0.25rem 0.75rem 0.25rem 0.75rem;
  background-color: #b41bb4;
  border-color: #b41bb4;
  color: white;
  border-radius: 6px !important;
}
.panel-input-email {
  background-color: #fff;
  border: 1px solid #bcbcbc !important;
  color: #4a4a4a;
  width: 100%;
  margin-right: 10px;
  color: #092d53 !important;
  border-radius: 6px 6px 0px 0px;
}
.border-radius-bottom {
  border-radius: 6px;
}
.border-radius-bottom > .input-custom {
  border-radius: 6px;
}
.input-custom {
  color: #16274a;
  background-color: white;
  border: 0;
  border-radius: 6px 6px 0px 0px;
  padding: 5px 10px;
}

.email-card {
  border-left: 1px solid #bcbcbc;
  border-right: 1px solid #bcbcbc;
  border-bottom: 1px solid #bcbcbc;
  height: 150px;
  overflow: auto;
  border-radius: 0px 0px 6px 6px;
}

.w-25 {
  width: 25%;
}
.email-box {
  background-color: #e2dff3;
  color: #7b7b7b !important;
  font-size: 14px;
  white-space: break-spaces;
  font-weight: 400 !important;
  border-radius: 25px;
}
.email-div {
  max-height: 150px;
  overflow-y: auto;
}
.text-email {
  word-break: break-word;
  overflow: hidden;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
}
.email-contain {
  color: white;
}
.bg-grey {
  background-color: #00000029;
}
.title-email {
  font-size: 16px;
}

.text-error {
  color: #ff0000;
  font-size: 14px;
}
.text-main-color {
  color: #40a9d1;
}
.main-color:disabled {
  opacity: 0.8;
  background-color: #16274a;
  color: white;
}
.text-black {
  color: black;
}
::v-deep .card {
  margin-bottom: 10px;
}
::v-deep .div-input {
  margin-bottom: 10px;
}
.w-cal-32xem {
  width: calc(100% - 2rem);
}

@media (max-width: 1200px) {
  .panel-input-email {
    max-width: 100%;
  }
}
</style>